// tslint:disable:no-bitwise
import {STRING_MAP} from "../../types";

export class Guid {
    static newGuid() {
        let d = new Date().getTime();
        const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
            const r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c === "x" ? r : (r & 0x3 | 0x8)).toString(16);
        });
        return uuid;
    }
}

// self implemented btoa to work both for client and server without importing module
export function btoa_se(str) {
    let buffer;

    if (str instanceof Buffer) {
        buffer = str;
    } else {
        // change "new Buffer(string, encoding)" to "Buffer.from(string, encoding)"
        // see https://stackoverflow.com/questions/52165333/deprecationwarning-buffer-is-deprecated-due-to-security-and-usability-issues
        buffer = Buffer.from(str.toString(), "binary");
    }

    return buffer.toString("base64");
}

export function atob_se(str) {
    // change "new Buffer(string, encoding)" to "Buffer.from(string, encoding)"
    // see https://stackoverflow.com/questions/52165333/deprecationwarning-buffer-is-deprecated-due-to-security-and-usability-issues
    return Buffer.from(str, "base64").toString("binary");
}


export function strMapToObj<P>(strMap: STRING_MAP<P>): any {
    const obj = Object.create(null);
    for (const [k, v] of <any>strMap) {
        // We don’t escape the key '__proto__'
        // which can cause problems on older engines
        obj[k] = v;
    }
    return obj;
}

export function objToStrMap<P>(obj): STRING_MAP<P> {
    const strMap = new Map<string, P>();
    for (const k of Object.keys(obj)) {
        strMap.set(k, obj[k]);
    }
    return strMap;
}


export function strMapToJson<P>(strMap: STRING_MAP<P>): string {
    return JSON.stringify(strMapToObj<P>(strMap));
}

export function jsonStrToStrMap<P>(jsonStr: string): STRING_MAP<P> {
    return objToStrMap<P>(JSON.parse(jsonStr));
}

export function jsonToStrMap<P>(jsonStr: any): STRING_MAP<P> {
    return objToStrMap<P>(jsonStr);
}
